import type { AbilityDef } from "../../sim";
import { CLIP_RANGES, strikeClipFrame } from "../clips";
import { ROOT_CURVES } from "./rootCurves";

/**
 * Ход корня приёма (консультант 04.11.2026: «перемещение бойца в мире совпадает с движением корня клипа»; Джон: «бьёт и
 * при этом не шагает, а скользит»): сдвиг вперёд по кадрам мира из движения бёдер клипа, в темпе удара
 * (`strikeClipFrame` — как рисует 3D). Мир прибавляет его к движению бойца.
 */
const ROOTED_POSES: readonly string[] = [
  "jab",
  "hook",
  "lightKick",
  "heavyKick",
  "uppercut",
  "cross",
  "bodyHook",
  "finisher",
  "frontKick",
  "elbowLunge",
  "overhandElbow",
  "risingElbow",
  "chargePunch",
  "chargeKick",
];

const at = (curve: readonly number[], frame: number): number => {
  const low = Math.max(0, Math.min(curve.length - 1, Math.floor(frame)));
  const high = Math.min(curve.length - 1, low + 1);
  const u = frame - Math.floor(frame);
  return (curve[low] ?? 0) * (1 - u) + (curve[high] ?? 0) * u;
};

/** Сдвиг по кадрам мира или undefined: у приёма нет хода корня (рывки и прыжки двигает действие, а не клип). */
export function rootMotionFor(ability: AbilityDef): readonly number[] | undefined {
  if (!ROOTED_POSES.includes(ability.pose) || ability.input.air || ability.actions?.length) return undefined;
  const range = CLIP_RANGES[ability.pose];
  const impact = range?.[3];
  const curve = range ? ROOT_CURVES[range[0]] : undefined;
  if (!range || impact === undefined || !curve) return undefined;
  const clipFrame = (t: number): number => strikeClipFrame(range, ability.startup, t);
  const total = ability.startup + ability.active + ability.recovery;
  const steps: number[] = [];
  for (let t = 0; t < total; t++)
    steps.push(Math.round((at(curve, clipFrame(t + 1)) - at(curve, clipFrame(t))) * 100) / 100);
  return steps;
}
